import { Response, httpGet, httpPatch } from "@config/http";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const { REACT_APP_BASE_URL } = process.env;

const initialState = {
  userEmail: "",
};

const getUser = createAsyncThunk("profile/update user", async () => {
  let results: Response | null;
  try {
    results = await httpGet(`${REACT_APP_BASE_URL}/api/v1/users/profile`, true);
    return Promise.resolve(results?.data);
  } catch (error) {
    return Promise.reject(error);
  }
});

const authorizationSlice = createSlice({
  name: "authorization",
  initialState: initialState,
  reducers: {
    setUser: (state, action) => {
      return { ...state, userEmail: action.payload };
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const authorizationReducer = authorizationSlice.reducer;

export const authorizationActions = {
  ...authorizationSlice.actions,
  getUser,
};
